import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { HELP_DOCUMENT_API} from "./apiRoutes";

interface mutateProps {
  id: string;
  data: FieldValues;
}

const mutateUpdateHelpDocument = async ({ data, id }: mutateProps) => {
  return await axiosAuth.patch(`${HELP_DOCUMENT_API}/${id}`, data, 
    { headers: { "Content-Type": "multipart/form-data" } }
  );
};

const useUpdateHelpDocumentMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateHelpDocument,
    ...queryParams,
  });

export default useUpdateHelpDocumentMutation;
